import moment from 'moment-timezone';

// Text used when displaying an availabilty in the list of availabilities for
// an advisor or technician. Standard is to use the time and advisor name.
// For online scheduler only we don't show the advisor if they don't have advisors.
// For mobile scheduler we don't show the specific time, but morning or afternoon instead.
export const availabilityOptionText = (concern, time, displayAdvisorSelection) => {
  if (time === "") return "";

  let timeWithZone = moment(time.moment).tz(window.gon.time_zone);
  let timeLabel = timeWithZone.format('h:mm a');

  if (concern.am_pm_availability_selection || window.gon.am_pm_availability_selection) {
    if (timeWithZone.hour() > 11) {
      timeLabel = 'Afternoon';
    } else if (timeWithZone.hour() <= 11) {
      timeLabel = 'Morning';
    }
  }

  return displayAdvisorSelection
    ? `${timeLabel} - ${time.name}`
    : `${timeLabel}`;
}

// Text used when displaying the user's chosen availability
// For mobile scheduler it will display 'Morning' or 'Afternoon'
// instead of a precise appointment time.
export const formattedChosenAvailability = (concern, time) => {
  if (time === "") return "";

  let timeWithZone = time.tz(window.gon.time_zone);
  let timeLabel = timeWithZone.format('h:mm a');

  if (concern.am_pm_availability_selection || window.gon.am_pm_availability_selection) {
    if (timeWithZone.hour() > 11) {
      timeLabel = 'Afternoon';
    } else if (timeWithZone.hour() <= 11) {
      timeLabel = 'Morning';
    }
  }

  return `${time.format('dddd MMMM Do YYYY')}, ${timeLabel}`;
}

export const filteredMorningAfternoonAvailabilities = (availabilties) => {
  let morningFound = false;
  let afternoonFound = false;

  return availabilties.filter(item => {
    if (item.name === "Unavailable") {
      return true; // Keep "Unavailable" items
    }

    const startTime = moment(item.moment).tz(window.gon.time_zone).format("HH");

    if (startTime < 12 && !morningFound) {
      morningFound = true;
      return true;
    }

    else if (startTime >= 12 && !afternoonFound) {
      afternoonFound = true;
      return true;
    }

    return !morningFound && !afternoonFound;
  });
}
